/* ====================================================================
 * TAGC Industries Served — canonical data source.
 *
 * Rendered on the landing page (<IndustriesServed />) as a bridge
 * between practice-area services and the categories they serve.
 * ==================================================================== */

const INDUSTRIES = [
  {
    id: 'cosmetics-personal-care',
    title: 'Cosmetics & Personal Care',
    items: [
      'Skin Care',
      'Hair Care',
      'Fragrance',
      'Color Cosmetics',
      'Professional Beauty',
      'Men’s Grooming',
    ],
  },
  {
    id: 'consumer-products',
    title: 'Consumer Products',
    items: [
      'Household Products',
      'Cleaning Products',
      'Air Care · see Home Fragrance & Air Care',
      'Pet Products',
      'Children’s Products',
    ],
  },
  {
    id: 'home-fragrance-air-care',
    title: 'Home Fragrance & Air Care',
    items: [
      'Candles & Scented Candles',
      'Reed Diffusers',
      'Room Sprays',
      'Plug-in Devices',
      'Wax Melts',
      'Incense',
      'Adjacent home-fragrance products',
    ],
  },
  {
    id: 'pharmaceuticals',
    title: 'Pharmaceuticals',
    items: [
      'Drug Products',
      'Drug Substances',
      'Manufacturing',
      'Pharmaceutical Development',
    ],
  },
  {
    id: 'medical-devices',
    title: 'Medical Devices',
    items: [
      'Patient Contact Devices',
      'Combination Products',
      'Medical Packaging',
      'Implantable Devices',
      'Disposable Devices',
    ],
  },
  {
    id: 'industrial-chemicals',
    title: 'Industrial Chemicals',
    items: [
      'Specialty Chemicals',
      'Raw Materials',
      'Chemical Manufacturers',
    ],
  },
  {
    id: 'environmental',
    title: 'Environmental',
    items: [
      'Sustainability Programs',
      'Chemical Stewardship',
      'Environmental Risk',
    ],
  },
];

export default INDUSTRIES;
